import { type RoomStateCubit } from '@breakoutlearning/firebase-repository/cubits/RoomStateCubit'
import { UserProfileRole } from '@breakoutlearning/firebase-repository/types'
import { BreakoutButton } from 'components/design-system/BreakoutButton'
import { useDialogs } from 'hooks/dialogs'
import { useBreakoutUser } from 'hooks/profile'
import { useRootStore } from 'hooks/rootStore'
import { useTranslationTyped } from 'i18n/i18n'
import { MeetingResultsDialog } from 'pages/student/assignment/dialogs/MeetingResultsDialog'

export const DemoMeetingEndedPage = ({
  roomStateCubit,
}: {
  roomStateCubit: RoomStateCubit
}) => {
  const { tt } = useTranslationTyped()
  const { profile, role } = useBreakoutUser()
  const rootStore = useRootStore()
  const { showDialog } = useDialogs()

  const isAnonymousDemoUser = profile.isAnonymous
  return (
    <div
      className="flex h-full w-full flex-col overflow-hidden bg-surface-dim lg:items-center lg:justify-center"
      data-testid="demo-meeting-ended-page"
    >
      <div className="mx-auto block h-full w-full max-w-[1280px] grid-cols-2 gap-3 space-y-4 overflow-y-auto p-7 lg:grid lg:space-y-0">
        <div className="flex flex-col justify-between gap-5 rounded-3xl bg-surface-bright px-14 py-10">
          <div>
            <div>
              <img
                src="/assets/images/logo_large_trimmed.png"
                width={160}
                alt={tt.breakout_learning()}
              />
            </div>
          </div>
          <div>
            <div
              className="text-headline-small text-on-surface"
              data-testid="demo-complete-heading"
            >
              {tt.demo.demo_complete()}
            </div>
            <div
              className="mt-3 text-display-medium text-on-surface"
              data-testid="demo-thank-you-text"
            >
              {tt.demo.thank_you()}
            </div>

            <div className="mt-6 text-label-large text-on-surface">
              {tt.demo.thank_you_long()}
            </div>
            <div className="mt-3 space-y-2">{/*  */}</div>
          </div>
          <div>
            <div className="flex items-center gap-4">
              <div className="flex-grow pr-4 text-body-large text-on-surface">
                {tt.demo.see_more()}
              </div>
              <div className="flex-shrink-0">
                <BreakoutButton
                  // disabled={!canJoinMeeting}
                  kind="primary"
                  size="large"
                  data-testid="demo-browse-catalog-button"
                  onClick={() => {
                    if (
                      isAnonymousDemoUser ||
                      role === UserProfileRole.student
                    ) {
                      window.location.href =
                        'https://www.breakoutlearning.com/catalog'
                      return
                    }

                    rootStore.navigateTo('instructorLibrary')
                  }}
                >
                  {tt.demo.browse_catalog()}
                </BreakoutButton>
              </div>
            </div>
            <div className="mt-10 flex items-center justify-center">
              <div className="flex-shrink-0">
                {roomStateCubit.roomId && roomStateCubit.roomWasGraded.get() ? (
                  <BreakoutButton
                    kind="primary"
                    size="large"
                    data-testid="demo-view-results-button"
                    onClick={() => {
                      showDialog(() => (
                        <MeetingResultsDialog roomId={roomStateCubit.roomId} />
                      ))
                    }}
                  >
                    {tt.demo.view_results()}
                  </BreakoutButton>
                ) : (
                  // if no results to view, just show old become a customer button
                  <BreakoutButton
                    kind="primary"
                    size="large"
                    onClick={() => {
                      rootStore.navigateTo('logout')
                    }}
                  >
                    {tt.demo.become_a_customer()}
                  </BreakoutButton>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="relative hidden overflow-hidden rounded-3xl bg-black lg:block">
          <img
            className="absolute left-1/2 top-0 h-full -translate-x-1/2 transform bg-left object-cover"
            src="/assets/images/breakout-face.png"
            alt=""
          />
        </div>
      </div>
    </div>
  )
}
